import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, inject, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { FileUploadModule } from 'primeng/fileupload';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { SelectModule } from 'primeng/select';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'app-user-profile',
  imports: [ButtonModule, SelectModule, CommonModule, PasswordModule, FormsModule, FileUploadModule, InputTextModule],
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss'
})
export class UserProfileComponent {
  private http = inject(HttpClient);
  private messageService = inject(MessageService);
  private userService = inject(UserService);
  currentPassword: string = '';
  imageUrl: string = JSON.parse(localStorage.getItem('user') || '{}').image_profile || 'https://modernize-angular-main.netlify.app/assets/images/profile/user-1.jpg';
  userFirstName: string = JSON.parse(localStorage.getItem('user') || '{}').first_name || '';
  userLastName: string = JSON.parse(localStorage.getItem('user') || '{}').last_name || '';

  userEmail: string = JSON.parse(localStorage.getItem('user') || '{}').email
    || '';
  userPhone: string = JSON.parse(localStorage.getItem('user') || '{}').phone_number
    || '';

  onFileSelected(event: Event): void {
    const target = event.target as HTMLInputElement;
    const file = target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', 'analytix');
    console.log('📂 File selected:', file.name);
    const cloudinaryUrl = 'https://api.cloudinary.com/v1_1/ds9embh9b/image/upload';
    this.http.post(cloudinaryUrl, formData).subscribe({
      next: (res: any) => {
        console.log('✅ Uploaded:', res.secure_url);
        this.imageUrl = res.secure_url;
      },
      error: (err) => {
        console.error('❌ Upload failed:', err);
      },
    });
  }

  cancelEdit() {
    this.userFirstName = JSON.parse(localStorage.getItem('user') || '{}').first_name || '';
    this.userLastName = JSON.parse(localStorage.getItem('user') || '{}').last_name || '';
    this.userEmail = JSON.parse(localStorage.getItem('user') || '{}').email || '';
    this.userPhone = JSON.parse(localStorage.getItem('user') || '{}').phone_number || '';
    this.imageUrl = JSON.parse(localStorage.getItem('user') || '{}').image_profile || 'https://modernize-angular-main.netlify.app/assets/images/profile/user-1.jpg';
  }
  saveChanges() {
    const payload = {
      user_id: JSON.parse(localStorage.getItem('user') || '{}').id || '',
      first_name: this.userFirstName,
      last_name: this.userLastName,
      image_profile: this.imageUrl
    };
    console.log('📤 Updating profile with:', payload);
    this.userService.updateUserProfile(payload).subscribe({
      next: (res: any) => {
        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Profil mis à jour' });
        const user = { ...payload,
          id : JSON.parse(localStorage.getItem('user') || '{}').id || '',
          isAdmin: JSON.parse(localStorage.getItem('user') || '{}').isAdmin,
          token: JSON.parse(localStorage.getItem('user') || '{}').token,
          email: this.userEmail};
        localStorage.setItem('user', JSON.stringify(user));
       

      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Échec de la mise à jour' });
      }
    });
  }
}
